import { formatCountdown } from '@/utils'

import {
  getSubTimerDisplayMs,
  getSubTimerElapsed,
  isSubTimerFinished,
  isSubTimerRunning,
  isSubTimerStarted,
} from '~shared/rundown/sub-timer-run'
import type { SubTimerState } from '~shared/rundown/sub-timer-run'

export type SubTimerView = ReturnType<typeof getSubTimerView>

/** What a sub timer shows at `now` (server ms): label, state and progress. */
export function getSubTimerView(timer: SubTimerState, now: number) {
  const ms = getSubTimerDisplayMs(timer, now)
  // formatCountdown ceils, so floor count-up values to show whole elapsed seconds
  const displayMs = timer.direction === 'up' ? Math.floor(ms / 1000) * 1000 : ms
  const finished = isSubTimerFinished(timer, now)
  return {
    label: formatCountdown(displayMs, '+'),
    running: isSubTimerRunning(timer, now),
    started: isSubTimerStarted(timer),
    over: timer.direction === 'down' && ms <= -1000,
    finished,
    progress:
      timer.direction === 'down' && timer.duration > 0
        ? Math.min(1, getSubTimerElapsed(timer, now) / timer.duration)
        : null,
  }
}
